import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerToDoSuggestedForm from '../containers/PlannerToDoSuggestedFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerToDoSuggestedAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerToDoSuggestedAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_to_do_suggested_route_add')} />
          <PlannerToDoSuggestedForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerToDoSuggestedAddScreen;

Logger.log('silly', `PlannerToDoSuggestedAddScreen loaded.`);